import React,{useState, useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import jardaction from '../../../context/action/report/jardaction';
import Jard_table from './jard_table';

const Jard = () => {
    const { initState, initDispatch, clear } = useContext(GlobalContext);

    const [category_id, setcategory_id] = useState("");
    const [barcode, setbarcode] = useState("");
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">ڕاپۆرت ← جەرد</h1>
                    <p className="text-sm text-slate-400 mt-0.5">داتا و وردەکاری کۆگا </p>
                </div>
            </div>
            {/* Add New Category Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 items-end">
                    <div className="w-full">
                        <label
                            for="catee"
                            className={
                                "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                        >
                                کاتیگۆری
                            </label>
                            <select
                            id="catee"
                            className={
                                "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            value={category_id}
                            onChange={(val) => {
                                setcategory_id(val.target.value);
                            }}
                        >
                        <option value="">کاتیگۆری</option>
                        {initState?.category.map((lis) => (
                            <option value={lis.category_id}>{lis.category_name}</option>
                        ))}
                        </select>
                    </div>
                    <div className="w-full">
                        <label
                            className={
                                "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            for="item_barcode"
                        >
                            کۆد
                        </label>
                        <input
                            className={
                                "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="item_barcode"
                            type="text"
                            placeholder=""
                            dir="ltr"
                            value={barcode}
                            onChange={(val) => setbarcode(val.target.value)}
                        />
                    </div>
                    <div className="w-full">
                        <button
                            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                            onClick={() => {
                                jardaction(
                                    category_id,
                                    barcode
                                )(initDispatch)(clear);
                            }}
                        >
                            جەرد
                        </button>
                    </div>
                </div>
            </div>
            {initState?.stok?.length > 0 && (
                <Jard_table />
            )}
        </div>
    )
}

export default Jard